import {
  Component, Element, Event,
  h, Listen, Prop, State,

} from '@stencil/core';
import {isMobile} from '../../../utils/media';

@Component({
  tag: 'svs-search-bar',
  styleUrl: 'svs-search-bar.scss',
  shadow: false,
})

export class SvsSearchBar {

  @Event({
    eventName: 'search:searchBarClicked',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    searchBarClicked;


  private rightToLeft = false;
  @State() hovered = false;
  @State() inputValue = '';

  /**
   * Sets the Search bar option: primary, or dedicated version for guided search component
   */
  @Prop() readonly option: 'primary' | 'guided' = 'primary';


  /**
   * Sets a placeholder value for the search input
   */
  @Prop() readonly placeholder: string = 'Search products, documents and more...';

  /**
   * Sets a text value for the cancel button
   */
  @Prop() readonly textCancel: string = 'Cancel';

  /**
   * Sets aria label for the search input
   */
  // eslint-disable-next-line @stencil-community/reserved-member-names
  @Prop() readonly ariaLabel: string = 'Search';

  /**
   * Sets a value for the the reset button
   */
  @Prop() readonly textReset: string = 'Reset';

  /**
   * Sets a value for the button search
   */
  @Prop() readonly textSearch: string;

  /**
   * Sets an action value for the search form
   */
  @Prop() readonly action: string = '/search';

  /**
   * Sets an action method for the search form
   */
  @Prop() readonly method: 'GET' | 'POST' = 'GET';

  /**
   * Enables right-to-left view
   */
  @Prop() readonly rtl: boolean;

  /**
   * Sets the Search dropdown
   */
  @Prop() readonly dropdown: boolean = false;

  /**
   * Sets the Search dropdown brand to get configuration from file
   */
  @Prop() readonly dropdownConfiguration: any; //eslint-disable-line @typescript-eslint/no-explicit-any

  /**
   * Sets hidden action parameter source
   */
  @Prop() readonly sourceParameter: string;

  /**
   * Sets initial value
   */
  @Prop() readonly initialValue?: string;

  @State() mobileView = isMobile();

  /**
   * Sets input autocomplete value
   */
  @Prop() readonly autocompleteValue: string = 'on';
  @State() showCancelButton = false;
  @Prop() readonly showQuantityInput: boolean = false;

  @Prop() readonly importance: string = 'emphasized';

  @Element() el;

  @Listen('resize', {target: 'window'})
  @Listen('load', {target: 'window'})
  handleResize() {
      this.mobileView = isMobile();
  }

  @Event({
    eventName: 'search:searchBarReady',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    searchBarReady;

  private formRef: HTMLFormElement;


  connectedCallback() {
      const body = this.el.closest('body');
      const html = this.el.closest('html');

      if (html) {
        const rtl = html.getAttribute('dir');
        if (rtl === 'rtl') {
          this.rightToLeft = true;
        }
      }

      if (body) {
        const rtl = body.getAttribute('dir');
        if (rtl === 'rtl') {
          this.rightToLeft = true;
        }
      }

      if (this.rtl) {
        this.rightToLeft = true;
      }

      if ((this.initialValue !== null && this.initialValue !== undefined) && this.inputValue === '') {
        this.inputValue = this.initialValue;
      }
  }

  componentDidLoad() {
      this.searchBarReady.emit();
  }

  render() {
      return (
        <div class="search-bar__container">
          <form dir={this.rightToLeft ? 'rtl' : 'auto'} class="search-bar__form" action={this.action} method={this.method}
            novalidate ref={(el) => (this.formRef = el as HTMLFormElement)}>
            <div class="search-bar__input-container">
              <div class={{'qds-control-group-inline': !this.mobileView, 'search-bar-control-group': true}}>
                {this.dropdown && !this.mobileView ?
                  <svs-guided-dropdown
                  // @ts-ignore
                    options={this.dropdownConfiguration}
                    disabled={false}
                  ></svs-guided-dropdown>
                  : ''}
                <qds-input
                  id="search-bar-input"
                  onInput={(e) => this.inputValue = (e.currentTarget as HTMLInputElement).value}
                  onClick={() => this.searchBarClicked.emit()}
                  onFocus={() => {
                      this.showCancelButton = true;
                  }}
                  value={this.initialValue}
                  label-aria={this.ariaLabel}
                  type="search"
                  name="q"
                  form={this.formRef}
                  placeholder={this.placeholder}
                  autocomplete={this.autocompleteValue}
                  size={'large'}
                  class="search-bar__input"
                  aria-invalid="false"
                  no-icon={!this.mobileView}
                />
                {this.sourceParameter ?
                  <input
                    type="hidden"
                    name="source"
                    value={this.sourceParameter}
                  />
                  : ''}
                {this.showQuantityInput ?
                  <qds-input
                    id="search-bar-input-quantity"
                    label-aria={this.ariaLabel}
                    type="number"
                    min="0"
                    name="quantity"
                    placeholder="Qty"
                    size={'large'}
                    class="search-bar__input-quantity"
                    aria-invalid="false"
                    no-icon
                  />
                  :
                  ''}
                {this.mobileView ? '' : <span class={'search-bar__button-container'}><qds-button
                  value={this.textSearch}
                  text={this.textSearch}
                  type="submit"
                  importance={this.importance}
                  icon-name={!this.textSearch && 'magnifying-glass'}
                  icon-library="default"
                  size="large"
                  icon-only="true"
                  class={'search-bar__button'}
                >
                </qds-button></span>}
              </div>
            </div>
          </form>
          {this.option === 'guided' && this.mobileView ? <qds-button importance="subdued"
            class={{'search-bar__cancel': true, 'search-bar__cancel--visible': this.showCancelButton}}
            type="button"
            text={this.textCancel}
            onClick={() => {
                this.showCancelButton = false;
            }}
          >
          </qds-button> : ''
          }
        </div>
      );
  }
}
